document.addEventListener("click", (event) => {
  const addButton = event.target.closest("[data-add-project-billing-term]");
  if (addButton) {
    const template = document.querySelector("[data-project-billing-term-template]");
    const body = document.querySelector("[data-project-billing-terms]");
    if (!template || !body) return;

    const key = `${Date.now()}${Math.floor(Math.random() * 1000)}`;
    body.insertAdjacentHTML("beforeend", template.innerHTML.replace(/NEW_RECORD/g, key));
    return;
  }

  const removeButton = event.target.closest("[data-remove-project-billing-term]");
  if (!removeButton) return;

  const row = removeButton.closest("tr");
  const destroyField = row.querySelector("[data-destroy-field]");
  if (destroyField && destroyField.value !== "") {
    destroyField.value = "1";
    row.hidden = true;
  } else {
    row.remove();
  }
});
